// Skeleton for the CPU Usage Card using Flowbite React
import { Card } from "flowbite-react";

const CpuUsageSkeleton = () => (
  <Card className="w-1/4 animate-pulse">
    <div className="h-[95px] flex flex-col justify-between">
      <div className="flex items-center justify-between">
        <div className="h-5 w-24 bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="h-6 w-6 bg-gray-300 dark:bg-gray-700 rounded-full" />
      </div>
      <div>
        <div className="h-6 w-16 bg-gray-300 dark:bg-gray-700 rounded mb-2" />
        <div className="h-4 w-20 bg-gray-200 dark:bg-gray-800 rounded" />
      </div>
    </div>
  </Card>
);

export default CpuUsageSkeleton;
